import { useMemo } from 'react';
import { MediaToggleBar, type MediaView } from './MediaToggleBar';
import { MonitoringMedia } from './MonitoringMedia';
import type { MonitoringPanelProps } from './MonitoringPanel';

export interface MonitoringBodyProps extends MonitoringPanelProps {
    mediaView: MediaView;
    onSelectView: (view: MediaView) => void;
    onToggleFullscreen?: () => void;
    isFullscreen?: boolean;
}

function MonitoringBody({
    mediaView,
    onSelectView,
    photos,
    photosLoading = false,
    selectedScanId,
    morphing = null,
    sidePanel,
    compareView,
    onToggleFullscreen,
    isFullscreen
}: MonitoringBodyProps) {
    const availableViews = useMemo<MediaView[]>(
        () => [
            'photos' as const,
            ...(morphing ? (['morphing'] as const) : []),
            ...(compareView ? (['compare'] as const) : [])
        ],
        [morphing, compareView]
    );

    return (
        <div className="flex-1 min-h-0 flex flex-col">
            {mediaView === 'compare' && compareView ? (
                <div className="flex-1 min-h-0 flex flex-col">{compareView}</div>
            ) : (
                <MonitoringMedia
                    mediaView={mediaView}
                    photos={photos}
                    photosLoading={photosLoading}
                    resetKey={selectedScanId ?? undefined}
                    morphing={morphing}
                    sidePanel={sidePanel}
                />
            )}
            {(availableViews.length > 1 || onToggleFullscreen) && (
                <MediaToggleBar
                    mediaView={mediaView}
                    availableViews={availableViews}
                    onSelect={onSelectView}
                    onToggleFullscreen={onToggleFullscreen}
                    isFullscreen={isFullscreen}
                />
            )}
        </div>
    );
}

export { MonitoringBody };
